import * as React from "react"
import * as TooltipPrimitive from "@radix-ui/react-tooltip"

import { cn } from "@/lib/utils"

function RichTooltip({
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Root>) {
  return <TooltipPrimitive.Root data-slot="rich-tooltip" {...props} />
}

function RichTooltipTrigger({
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Trigger>) {
  return <TooltipPrimitive.Trigger data-slot="rich-tooltip-trigger" {...props} />
}

function RichTooltipContent({
  className,
  sideOffset = 0,
  children,
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Content>) {
  return (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        data-slot="rich-tooltip-content"
        sideOffset={sideOffset}
        className={cn(
          "z-50 w-fit max-w-xs origin-[var(--radix-tooltip-content-transform-origin)] rounded-xl border border-white/10 bg-background/85 px-4 py-3 text-xs leading-relaxed text-foreground shadow-2xl backdrop-blur-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
          className
        )}
        {...props}
      >
        {children}
        <TooltipPrimitive.Arrow className="z-50 size-3 translate-y-[calc(-50%_-_2px)] rotate-45 rounded-[2px] border border-white/10 bg-background/85 fill-background/85 backdrop-blur-md" />
      </TooltipPrimitive.Content>
    </TooltipPrimitive.Portal>
  )
}

export { RichTooltip, RichTooltipTrigger, RichTooltipContent }

